<div class="col-xl" *ngIf="provider">
    <div class="card mb-3">
        <div class="card-body d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div class="d-flex align-items-center gap-3">
                <div class="provider-detail-avatar" [style.background]="avatarBg" [style.color]="avatarColor">{{ initials() }}</div>
                <div>
                    <h4 class="provider-detail-name mb-1">{{ provider.trade_name || provider.business_name }}</h4>
                    <p class="provider-detail-subtitle mb-0">{{ provider.provider_type || '—' }}</p>
                </div>
            </div>
            <a class="btn btn-outline-info provider-edit-btn" [routerLink]="['/provider/update', providerId]" [queryParams]="{ name: provider.trade_name || provider.business_name }">
                <img src="assets/img/provider/icon-edit.svg" alt="" width="16" height="16" class="me-1">
                Editar proveedor
            </a>
        </div>
    </div>

    <ul class="nav provider-detail-tabs">
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="tab === 'general'" (click)="setTab('general')">
                <img src="assets/img/provider/icon-tab-general.svg" alt="" width="20" height="20">
                Datos generales
            </button>
        </li>
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="tab === 'historial'" (click)="setTab('historial')">
                <img src="assets/img/provider/icon-tab-historial.svg" alt="" width="20" height="20">
                Historial de pagos
            </button>
        </li>
    </ul>

    <div class="card provider-detail-card">
        <div class="card-body">

            <ng-container *ngIf="tab === 'general'">
                <h5 class="section-title mb-3 d-flex align-items-center gap-2">
                    <img src="assets/img/provider/icon-user-square.svg" alt="" width="18" height="18">
                    Información general
                </h5>
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <label class="detail-label">Razón social</label>
                        <p class="detail-value">{{ provider.business_name }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Nombre comercial</label>
                        <p class="detail-value">{{ provider.trade_name || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Tipo de proveedor</label>
                        <p class="mb-0">
                            <span class="provider-type-badge" *ngIf="provider.provider_type">{{ provider.provider_type }}</span>
                            <span class="detail-value" *ngIf="!provider.provider_type">—</span>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">RFC</label>
                        <p class="detail-value">{{ provider.rfc }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Correo electrónico</label>
                        <p class="detail-value">{{ provider.email || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Teléfono</label>
                        <p class="detail-value">{{ provider.phone || '—' }}</p>
                    </div>
                    <div class="col-md-12">
                        <label class="detail-label">Dirección fiscal</label>
                        <p class="detail-value">{{ provider.fiscal_address || '—' }}</p>
                    </div>
                </div>

                <h5 class="section-title mb-3 d-flex align-items-center gap-2">
                    <img src="assets/img/provider/icon-bank.svg" alt="" width="18" height="18">
                    Información bancaria
                </h5>
                <div class="row g-3">
                    <div class="col-md-4">
                        <label class="detail-label">Banco</label>
                        <p class="detail-value">{{ provider.bank_name || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Nombre del beneficiario</label>
                        <p class="detail-value">{{ provider.beneficiary_name || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Tipo de cuenta</label>
                        <p class="detail-value">{{ provider.account_type || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">Cuenta</label>
                        <p class="detail-value">{{ provider.account_number || '—' }}</p>
                    </div>
                    <div class="col-md-4">
                        <label class="detail-label">CLABE</label>
                        <p class="detail-value">{{ provider.clabe || '—' }}</p>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="tab === 'historial'">
                <p class="text-muted text-center py-5">
                    El historial de pagos estará disponible cuando se implemente el módulo de Pagos a Proveedores.
                </p>
            </ng-container>

        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
